<div [hidden]="!isOnLoading" class="mtm-download-upload-progress-icon" [style.width.px]="widthInPixel" [style.height.px]="widthInPixel">
  <mtm-loading-spinner [size]="widthInPixel"></mtm-loading-spinner>
</div>
